export const PLUGIN_NAME = 'indicator';
